/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type SelectOption, I18nService } from '@dm/core';
import { DiskTypeOpts } from 'app/common/constants/disk-type';
import { ToolService } from 'app/common/services';

import { PlayTimeInterval, PlayTimeIntervalLabel } from './export.const';
import { LogType, NodeType } from './export.enum';

@Injectable()
export class ExportStrService {
    i18nLabel = {
        type: this.i18n.get('common.type_column'),
        name: this.i18n.get('common.name_column'),
        title: this.i18n.get('system.exportData_task_title_label'),
        closeBtn: this.i18n.get('common.close_button'),
        download: this.i18n.get('system.exportData_term_export_link'),
        downloadAll: this.i18n.get('system.exportData_task_para_exportHistoryLog_list'),
        downloadRecent: this.i18n.get('system.exportData_task_para_exportRecentLog_list'),
        downloadPrivate: this.i18n.get('system.exportData_task_para_exportPrivateLog_list'),
        downloadDHA: this.i18n.get('system.exportData_task_para_exportDha_button'),
        downloadHSSD: this.i18n.get('system.exportData_task_para_exportHSSD_button'),
        downloadEraseReport: this.i18n.get('system.exportData_task_para_exportErase_button'),
        sourceLabel: this.i18n.get('system.exportData_term_logSource_label'),
        nodeLabel: this.i18n.get('system.exportData_task_node_col'),
        statusLabel: this.i18n.get('common.status_label'),
        chromeExplain: this.i18n.get('system.exportData_term_explain_label'),
        failed: this.i18n.get('common.downloadFailed_label'),
        success: this.i18n.get('common.downloadsuccess_label'),
        loading: this.i18n.get('system.exportData_task_exporting_lab'),
        baseErr: this.i18n.get('system.exportData_term_failExportData_label'),
        confirmMsg: this.i18n.get('system.exportData_term_info_message'),
        baseDesc: this.i18n.get('system.exportData_term_info_Import_msg'),
        [LogType.runningData]: this.i18n.get('system.exportData_task_para_exportRunningData_description_label'),
        [LogType.system]: this.i18n.get('system.exportData_task_para_exportSysLog_description_label'),
        [LogType.disk]: this.i18n.get('system.exportData_task_para_exportdha_description_label'),
        [LogType.diagnostic]: this.i18n.get('system.exportData_task_para_diagnoseInform_description_label'),
        [LogType.cloudBackup]: this.i18n.get('system.exportData_task_cloudbackupLog_desc_lab'),
        [LogType.antivirus]: this.i18n.get('system.exportData_task_para_exportPerformFile_desc'),
        [LogType.performanceFile]: this.i18n.get('system.exportData_task_para_exportPerformFile_desc'),
        [LogType.antivirus]: this.i18n.get('system.exportData_task_para_exportAntinus_desc'),
        [LogType.ftds]: this.i18n.get('system.exportData_task_para_exportFTDS_desc'),
        [LogType.DISK_RUNING_STATUS_DATA]: this.i18n.get('system.exportData_task_para_exportDiskRunningStatus_info'),
        runningMsg: this.i18n.get('system.exportData_term_exportRunningData_warn_message'),
        warningMsg: this.i18n.get('system.exportData_term_exportlog_warn_message'),
        eraseMsg: this.i18n.get('system.systemSetting_exportData_task_para_diskDataErasure_msg'),
        warningMsgOneHour: this.i18n.get('system.exportData_term_exportDiagnosticFile_warn_message'),
        exportTimeout: this.i18n.get('common.task_progressTimeout_tip'),
        exportSysLogTip: this.i18n.get('system.exportData_task_para_exportSysLog_tip'),
        exportdhaTip: this.i18n.get('system.exportData_task_para_exportdha_tip'),
        exportSystemLogTip: this.i18n.get('system.exportData_task_para_exportdhaAnti_err_tip'),
        exportDhaLogTip: this.i18n.get('system.exportData_task_para_exportSysAnti_err_tip'),
        exportAntinusLogTip: this.i18n.get('system.exportData_task_para_exportSysDha_err_tip'),
        exportFTDSLogTip: this.i18n.get('system.exportData_task_para_exportFTDS_err_tip'),
        exportSystemLogSanTip: this.i18n.get('system.exportData_task_para_exportdhaAnti_san_err_tip'),
        exportDhaLogSanTip: this.i18n.get('system.exportData_task_para_exportSysAnti_san_err_tip'),
        exportFTDSLogSanTip: this.i18n.get('system.exportData_task_para_exportFTDS_san_err_tip'),
        exportConflictPrompt: this.i18n.get('system.exportData_task_exportTaskConflict_info'),

        systemLabel: this.i18n.get('system.exportData_task_para_exportSysLog_label'),
        diskLabel: this.i18n.get('system.exportData_task_para_exportdha_label'),
        runningDataLabel: this.i18n.get('system.exportData_task_para_exportRunningData_label'),
        diagnosticLabel: this.i18n.get('system.exportData_task_para_diagnoseInform_label'),
        antivirusLabel: this.i18n.get('system.exportData_task_para_exportAntinus_label'),
        performanceFileLabel: this.i18n.get('system.exportData_task_para_exportPerformFile_label'),
        ftdsLabel: this.i18n.get('system.exportData_task_para_exportFTDS_label'),

        equalTip: this.i18n.get('system.exportData_task_PwdnotSame_err_lab'),
        isEncryptLab: this.i18n.get('common.enable_label'),
        encryptPasswordLab: this.i18n.get('system.exportData_task_encryptPwd_lab'),
        encryptConfirmPasswordLab: this.i18n.get('system.exportData_task_comfirmPwd_lab'),
        encryptLab: this.i18n.get('system.exportData_task_dataEncrypt_lab'),
        keyComplexTip: this.i18n.get('common.newPassword_short_tip3'),
        useEncryptTip: this.i18n.get('system.exportData_task_dataEncrypt_info_lab'),
        complexTip: this.i18n.get('common.newPassword_short_tip2'),
        keyComplexErrorTip: this.i18n.get('settings.securityPolicy_task_username_para_passwdPolicy_complexity_normal'),

        noPmsLunNoDataTip: this.i18n.get('home.performance_term_exportPerformFile_tip'),
        noPmsLunHistoricalDataTip: this.i18n.get('home.performance_term_enable_historicalData_tip'),
        preiodLab: this.i18n.get('common.Punctuation_preiod'),

        exportDataTimeLabel: this.i18n.get('system.exportData_task_para_exportData_label'),

        exportFailedDownloadingStatus: this.i18n.get('rest.exportPerformFileFailCause_downloading'),
        exportFailedFaultStatus: this.i18n.get('rest.exportPerformFileFailCause_fault'),
        exportFailedNoneStatus: this.i18n.get('rest.exportPerformFileFailCause_none'),
        exportFailedFailStatus: this.i18n.get('rest.exportPerformFileFailCause_failed'),

        language: this.i18n.getLanguage(),
        exportFailedReasonDesc: this.i18n.get('system.exportData_task_para_failReason_desc'),
        exportFailedSuggestDesc: this.i18n.get('system.exportData_task_para_failSuggest_desc'),

        exportByNode: this.i18n.get('system.exportData_task_exportByNode_lab'),
        availableNode: this.i18n.get('system.exportData_task_availableNode_lab'),
        selectedNode: this.i18n.get('system.exportData_task_selectedNode_lab'),
        type_expansionBoard: this.i18n.get('system.exportData_task_type_expansionBoard_value'),
        duration: this.i18n.get('system.exportData_task_duration_lab', true),
        size: this.i18n.get('settings.upgrade_task_size_lab', true),
        aboutTime: (time: string): string => this.i18n.get('system.exportData_task_time_value', [time]),
        aboutSize: (size: string): string => this.i18n.get('system.exportData_task_size_value', [size]),
        yes: this.i18n.get('common.term_yes_label'),
        no: this.i18n.get('common.term_No_label'),
        includeManagementLogLab: this.i18n.get('system.exportData_task_includeManagementLog_lab'),
        includeManagementLogTip: this.i18n.get('system.exportData_task_includeManagementLog_tip'),
        includeManagementLogEnableInfo: this.i18n.get('system.exportData_task_includeManagementLog_enable_info'),
        exportRecentLogTip: this.i18n.get('system.exportData_task_para_exportRecentLog_tip'),
        totalDuration: this.i18n.get('system.exportData_task_totalDuration_lab', true),
        totalSize: this.i18n.get('system.exportData_task_totalSize_lab', true),
        exportEraseLogByNodesTtip: this.i18n.get('system.exportData_task_para_exportEraseLogByNodes_err_tip'),
        exportRecentLogErrTip: this.i18n.get('system.exportData_task_para_exportRecentLog_err_tip'),
        numUpLimit: this.i18n.get('system.exportData_task_numUpLimit_err_tip'),
        recommendedMethod: this.i18n.get('monitor.alarmAndLog_simplifiedMode_infoCollect_btn'),
        recommendedDes: this.i18n.get('monitor.alarmAndLog_simplifiedMode_suggestion_info'),
        systemInfoTitle: this.i18n.get('monitor.alarmAndLog_simplifiedMode_systemInfo_lab'),
        diagnosisInfoTitle: this.i18n.get('monitor.alarmAndLog_simplifiedMode_diagnosisInfo_lab'),
        cancelBtn: this.i18n.get('common.cancel_button'),
        cancelExport: this.i18n.get('system.exportData_term_cancelExportData_title'),
        cancelExportPerfTip: this.i18n.get('system.exportData_term_fileDateRange_tip'),
        cancelExportPerfContent: this.i18n.get('system.exportData_term_cancelExportPerformFile_confirm_msg'),
        perfFileExportMsg: this.i18n.get('system.exportData_term_exportPerformFile_confirm_msg'),
        downloadLogLabel: this.i18n.get('common.logDownLoad_lab'),
        downloadBtn: this.i18n.get('system.exportData_term_downLoad_link'),
        streamlineDiagnosticLabel: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_label'),
        // 精简诊断文件导出下方增加录屏二维码提示内容
        streamLineDianosticCollectQRcodeLable: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_CollectQRcode_info'),
        [LogType.streamlineDiagnostic]: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_info'),
        fullDiagnosticQrcodeLabel: this.i18n.get('system.exportData_task_para_keyDiagnoseQRCode_info'),
        fullDiagnosticQrcodeSpeedLabel: this.i18n.get('system.exportData_task_para_keyDiagnoseQRCode_playSpeed_lab'),
        copyBtn: this.i18n.get('common.copy_button'),
        collectBtn: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_collect_btn'),
        recollectBtn: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_collectAgain_btn'),
        noCollectTip: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_collect_info'),
        exportStreamlineDiagnosticLogTip: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_export_tip'),
        timeInfo: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_lastCollectTime_info'),
        timeLab: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_lastCollectTime_lab'),
        fileNonexportableTip: this.i18n.get('system.exportData_task_para_keyDiagnoseInform_export_err_tip'),
        fullScreenTip: this.i18n.get('common.fullScreen_button'),
        //硬盘SN
        diskSnLable: this.i18n.get('system.SN'),
        //硬盘型号
        diskModelLable: this.i18n.get('system.hardware_term_diskMode_label'),
        //类型
        diskStyleLable: this.i18n.get('system.type_column'),
        //硬盘厂商
        diskManufacturerLable: this.i18n.get('system.hardware_term_Manufacturer_label'),
        //硬盘FW（固件版本）
        diskFWLable: this.i18n.get('system.hardware_term_FirmwareVer_label'),
        //硬盘容量
        diskCapacityLable: this.i18n.get('system.exportData_task_para_exportDiskRunningStatus_cap_col'),
        //硬盘厂商容量
        diskManuCapacityLable: this.i18n.get('system.exportData_task_para_exportDiskRunningStatus_manufactCap_col'),
        //硬盘BOM
        diskBomLable: this.i18n.get('system.common_term_electricItem_label'),
        //硬盘21条码
        diskBarcodeLable: this.i18n.get('system.hardware_term_barcode_column'),
        //硬盘剩余天数
        diskRemainLifeLable: this.i18n.get('system.exportData_task_para_exportDiskRunningStatus_estimatedLifespan_col'),
        //硬盘运行时间
        diskRuntimeLable: this.i18n.get('system.hardware_term_diskRunTime_label'),
        //硬盘运行状态
        diskRunningStatusLable: this.i18n.get('system.exportData_task_para_exportDiskRunningStatus_label'),
    };

    /**
     * 关键信息二维码播放速度选项
     */
    playSpeedOptionsOptions: SelectOption[] = [
        {
            label: this.i18n.get('system.exportData_task_para_keyDiagnoseQRCode_playSpeed_value',
                [PlayTimeIntervalLabel.THREE_HUNDRED_MIllISECONDS]),
            value: PlayTimeInterval.THREE_HUNDRED_MIllISECONDS,
        },
        {
            label: this.i18n.get('system.exportData_task_para_keyDiagnoseQRCode_playSpeed_value',
                [PlayTimeIntervalLabel.FIVE_HUNDRED_MIllISECONDS]),
            value: PlayTimeInterval.FIVE_HUNDRED_MIllISECONDS,
        },
        {
            label: this.i18n.get('system.exportData_task_para_keyDiagnoseQRCode_playSpeed_value', [PlayTimeIntervalLabel.ONE_SECONDS]),
            value: PlayTimeInterval.ONE_SECONDS,
        },
        {
            label: this.i18n.get('system.exportData_task_para_keyDiagnoseQRCode_playSpeed_value',
                [PlayTimeIntervalLabel.ONE_POINT_FIVE_SECONDS]),
            value: PlayTimeInterval.ONE_POINT_FIVE_SECONDS,
        },
        {
            label: this.i18n.get('system.exportData_task_para_keyDiagnoseQRCode_playSpeed_value', [PlayTimeIntervalLabel.TWO_SECONDS]),
            value: PlayTimeInterval.TWO_SECONDS,
        },
        {
            label: this.i18n.get('system.exportData_task_para_keyDiagnoseQRCode_playSpeed_value',
                [PlayTimeIntervalLabel.TWO_POINT_FIVE_SECONDS]),
            value: PlayTimeInterval.TWO_POINT_FIVE_SECONDS,
        },
        {
            label: this.i18n.get('system.exportData_task_para_keyDiagnoseQRCode_playSpeed_value', [PlayTimeIntervalLabel.THREE_SECONDS]),
            value: PlayTimeInterval.THREE_SECONDS,
        },
    ];

    nodeType = [
        {
            label: this.i18n.get('monitor.charts_term_objectType_CONTROLLER'),
            value: NodeType.CONTROLLER,
        },
        {
            label: this.i18n.get('system.hardware_term_expansionBoard_label'),
            value: NodeType.EXPANSION_BOARD,
        },
    ];

    btnTipConfig = {
        [LogType.system]: {
            time: 10,
            controllers: 60,
        },
        [LogType.system + 'all']: {
            time: 15,
            controllers: 100,
            expansionBoard: 20,
        },
        [LogType.system + 'allInPrompt']: {
            time: 25,
            controllers: 300,
            expansionBoard: 50,
        },
        [LogType.system + 'private']: {
            time: 5,
            controllers: 100,
            expansionBoard: 30,
        },
        [LogType.dha]: {
            time: 5,
            controllers: 10,
            expansionBoard: 10,
        },
        [LogType.hssd]: {
            // 每个引擎（控制框、硬盘框）下每个硬盘的时间，同时选中两个引擎的控制器或级联模块，按最大值计算
            diskTime: 0.08,
            controllers: 16,
            expansionBoard: 0.72,
        },
        [LogType.erase]: {
            time: 10,
            controllers: 10,
        },
        [LogType.runningData]: {
            time: 5,
            totalSize: 30,
        },
        [LogType.diagnostic]: {
            time: 10,
            totalSize: 30,
        },
        [LogType.ftds]: {
            time: 2.5,
            controllers: 200,
        },
        [LogType.performanceFile]: {
            time: 30,
            controllers: 100,
        },
        [LogType.DISK_RUNING_STATUS_DATA]: {
            time: 10,
            totalSize: 2,
        },
    };

    constructor(
        private i18n: I18nService,
        private toolService: ToolService,
    ) { }

    minPasswordLengthTip = (minPasswordLength: number): string => this.i18n.get('common.lengthEqual_Num_tip', [minPasswordLength]);
    passwordLengthTip = (minPasswordLength: number, maxPasswordLength: number): string =>
        this.i18n.get('common.length_msg', [minPasswordLength, maxPasswordLength]);
    encryptPasswordRequiredTip = (encryptPassword: string): string => this.i18n.get('common.null_validation', [encryptPassword]);
    encryptConfirmPasswordRequiredTip = (encryptConfirmPassword: string): string =>
        this.i18n.get('common.null_validation', [encryptConfirmPassword]);
    exportDataTimeLimitTip = (day: number): string => this.i18n.get('system.exportData_task_para_exportData_desc', [day]);
    diskTypeOpttions = this.toolService.convertEnumToOptions(DiskTypeOpts);
}
